import { ReactComponent as FlagIcon } from "./svg/th-flag.svg";
import "../flag-icon.scss";

export const THFlag = () => {
  return (
    <span className="flag-icon">
      <FlagIcon />
    </span>
  );
};
